import type { BetslipState } from "sections/Betting/Betslip/betslipSlice";
import type { Context } from "../models/context";

const betslipToUsedAllocations = (
  betslip: BetslipState,
): Context["usedAllocations"] => {
  return Object.values(betslip.selections).reduce(
    (outcomeIdsByAllocation, selection) => {
      if (!selection.allocationId) return outcomeIdsByAllocation;

      return {
        ...outcomeIdsByAllocation,
        [selection.allocationId]:
          betslip.betType === "MULTI" ? "multi" : selection.outcomeId,
      };
    },
    {},
  );
};

export { betslipToUsedAllocations };
